import React from 'react';
import Editor from "@monaco-editor/react";

import * as Antd from 'antd';
import * as AntdIcons from '@ant-design/icons';
import * as SYS from '.';


export const FormForm = props => {
    const [form] = Antd.Form.useForm();

    const layout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
    };

    const tailLayout = {
        wrapperCol: { span: 18, offset: 6 },
    };

    return (
        <Antd.Form
            {...layout}
            form={form}
            initialValues={props.initialValues}
            onFinish={values => {
                values.content = SYS.toBinaryV2(values.decodedContent);

                // auxiliary : will be removed
                values.contentType = 'base64v2';

                delete values.decodedContent;
                if (props.onSuccess) {
                    props.onSuccess(values);
                }
            }}
            onFinishFailed={(err) => {
                console.log(err);
            }}
        >
            <Antd.Row>
                <Antd.Col span={8}>
                    {props.initialValues && props.initialValues.id
                        ? <Antd.Form.Item name="id" label="ID">
                            <Antd.Input disabled={true} />
                        </Antd.Form.Item>
                        : null}
                    <Antd.Form.Item
                        name="code"
                        label="Code"
                        rules={[{ required: true }]}
                    >
                        <Antd.Input />
                    </Antd.Form.Item>
                    <Antd.Form.Item
                        name="name"
                        label="Name"
                        rules={[{ required: true }]}
                    >
                        <Antd.Input />
                    </Antd.Form.Item>
                    <Antd.Form.Item
                        name="action"
                        label="Action"
                        rules={[{ required: true }]}
                    >
                        <Antd.Input />
                    </Antd.Form.Item>
                    <Antd.Form.Item
                        name="layout"
                        label="Layout"
                        rules={[{ required: true }]}
                    >
                        <Antd.Radio.Group>
                            <Antd.Radio.Button value="horizontal">Horizontal</Antd.Radio.Button>
                            <Antd.Radio.Button value="vertical">Vertical</Antd.Radio.Button>
                        </Antd.Radio.Group>
                    </Antd.Form.Item>
                </Antd.Col>
                <Antd.Col span={16}>
                    <Antd.Form.Item
                        noStyle
                        name="decodedContent"
                        label="Content"
                        rules={[{ required: true }]}
                    >
                        <Editor
                            height="80vh"
                            options={{
                                fontSize: 12
                            }}
                            defaultLanguage="javascript"
                            {...props}
                        />
                    </Antd.Form.Item>
                </Antd.Col>
            </Antd.Row>

            <Antd.Form.Item
                {...tailLayout}
                style={{
                    marginTop: 10
                }}
            >
                <Antd.Button
                    type="primary"
                    htmlType="submit"
                >
                    Submit
                </Antd.Button>
            </Antd.Form.Item>
        </Antd.Form >
    );
}